import { FileUtils } from "./FileUtils";

interface ReportData {
  blockName: string;
  userName: string;
  uploadSummary: {
    totalFiles: number;
    startDateTime: string;
    endDateTime: string;
    uploadTime: number;
    processingTime: number;
  };
  justProcessedFiles: any[];
}

export const downloadProcessingReport = (data: ReportData) => {
  const { uploadSummary, justProcessedFiles, blockName, userName } = data;

  const successCount = justProcessedFiles.filter(
    (f) => f.status === "success",
  ).length;
  const successRate = ((successCount / uploadSummary.totalFiles) * 100).toFixed(
    1,
  );

  const headers = [
    "Filename",
    "Size",
    "Status",
    "Extracted Date",
    "Oil Production",
    "Oil IPC",
    "Val. Variance",
    "Azure Upload",
    "DB Prod Write",
    "DB Def Write",
    "Error Message",
  ];

  const fileRows = justProcessedFiles.map((file) => {
    // Access nested 'checks' from p_B18_31
    const checks = file.checks || {};

    return [
      `"${file.filename}"`,
      `"${FileUtils.formatFileSize(file.fileSize || 0)}"`,
      `"${file.status || "unknown"}"`,
      `"${checks["Doc Date"] || "N/A"}"`,
      `"${checks.oilProduction || 0}"`,
      `"${checks.oilIPC || 0}"`,
      // total_val_error is your 'def_check' math from backend
      `"${checks.total_val_error !== undefined ? checks.total_val_error.toFixed(2) : "N/A"}"`,
      `"${file.upload_status || "N/A"}"`,
      `"${checks["dB write production"] === true ? "SUCCESS" : "SKIPPED/FAIL"}"`,
      `"${checks["dB write deferrals"] === true ? "SUCCESS" : "SKIPPED/FAIL"}"`,
      `"${(file.error || "").replace(/"/g, '""')}"`,
    ];
  });

  // 3. Add Summary Metadata (Includes Block and User)
  const summaryRows = [
    ["--- SESSION SUMMARY ---"],
    ["Block Name", `"${blockName}"`],
    ["Processed By", `"${userName}"`],
    ["Total Files", uploadSummary.totalFiles],
    [
      "Success Rate",
      `${successRate}% (${successCount}/${uploadSummary.totalFiles})`,
    ],
    ["Start Time", uploadSummary.startDateTime],
    ["End Time", uploadSummary.endDateTime],
    ["Upload Duration", uploadSummary.uploadTime, "s"],
    ["Processing Duration", uploadSummary.processingTime, "s"],
    [
      "Average Upload Duration",
      uploadSummary.uploadTime / uploadSummary.totalFiles,
      "s per file",
    ],
    [
      "Average Processing Duration",
      uploadSummary.processingTime / uploadSummary.totalFiles,
      "s per file",
    ],
    [""],
    ["--- FILE DETAILS ---"],
    headers,
  ];

  // 4. Combine to CSV string
  const csvContent = [...summaryRows, ...fileRows]
    .map((e) => e.join(","))
    .join("\n");

  // 5. Trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  // Clean the time string (e.g., "14:30:05" becomes "14-30-05")
  const cleanStartTime = uploadSummary.startDateTime
    .replace(/:/g, ".")
    .replace(/\s/g, "");
  const cleanDate = new Date().toLocaleDateString("en-GB").replace(/\//g, "-");
  link.setAttribute("href", url);
  // Filename now includes the Block Name for better organization
  link.setAttribute(
    "download",
    `Block_${blockName.replace(/\s+/g, "_")}_Upload_Report_${cleanStartTime}_${cleanDate}.csv`,
  );
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
